/**
 * Staff roles (users.role). Patients are role 2 and never sign in to this panel.
 * The numbers are the server's: they are NOT in display order - use ROLE_ORDER for that.
 */
export const DOCTOR = 1;

/** The old name for DOCTOR (role 1 was "clinical admin" before the three-role split). */
export const CLINICAL_ADMIN = DOCTOR;

export const SUPER_ADMIN = 3;

export const ADMIN = 4;

/**
 * A staff member's ACCOUNT role by name - for admin screens only: the Clinicians page (Role column,
 * Change role), Role history, Staff activity and Log history. Never on a clinical screen: there,
 * whoever ran the consultation is "Doctor" (clinicalRoleLabel below).
 */
export const ROLE_LABELS = {
    [DOCTOR]: "Doctor",
    [ADMIN]: "Admin",
    [SUPER_ADMIN]: "Super admin",
};

/** The order the roles are listed in (Change role, anywhere else they are offered together). */
export const ROLE_ORDER = [DOCTOR, ADMIN, SUPER_ADMIN];

/** Every role that signs in to this panel. */
export const STAFF_ROLES = ROLE_ORDER;

/** Whether this role is a staff role (Doctor, Admin or Super admin) - never true for a patient. */
export function isStaffRole(role) {
    return STAFF_ROLES.includes(role);
}

/**
 * What a clinical screen calls the person who ran a consultation (held the session as its doctor,
 * wrote the notes, issued the fit note, prescription or referral), and anyone the header search finds
 * as a clinician. Super admins and Admins with a doctors row run consultations too, and they do it as
 * the doctor: a patient's record must not say "Super admin" or "Admin" next to the notes they wrote
 * (Sunil, 24 Oct 2026). So it is always "Doctor" here, whatever the account role - ROLE_LABELS is
 * for the admin screens, which still need it.
 */
export const CLINICAL_ROLE_LABEL = "Doctor";

/**
 * @param {*} role  users.role of whoever ran the consultation (or was found as a clinician)
 * @returns {string} "Doctor" for any staff role - Doctor (1), Admin (4) or Super admin (3) alike;
 *   "-" when there is no one, or the role is not a staff role
 */
export function clinicalRoleLabel(role) {
    return isStaffRole(role) ? CLINICAL_ROLE_LABEL : '-';
}
